import { render, staticRenderFns } from "./local-case-types-modal-basic-form-sample-types.vue?vue&type=template&id=00a818a3&scoped=true&"
import script from "./local-case-types-modal-basic-form-sample-types.ts?vue&type=script&lang=ts&"
export * from "./local-case-types-modal-basic-form-sample-types.ts?vue&type=script&lang=ts&"
import style0 from "./local-case-types-modal-basic-form-sample-types.scss?vue&type=style&index=0&id=00a818a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a818a3",
  null
  
)

export default component.exports